<template>
  <div>
    <SubHeader
      :title="subHeaderTitle"
      :breads="[
        { name: 'IA', to: 'AdminUserProfileProfile' },
        { name: 'Dossiers', to: 'AdminUserProfileProfile' },
      ]"
      :action="{}"
    />

    <div class="row">
      <div class="col-md-12">
        <div class="row justify-content-between align-items-center flex-grow-1">
          <div class="col-12 col-md"></div>
        </div>
        <div
          class="card-body datatable-custom position-relative table-responsive"
        >
          <div class="row align-items-center mb-5">
            <div class="col">
              <h2 class="mb-0">
                <b
                  >Classement des plaintes — Priorité
                  <span :class="getPriorityClass(filter)">{{ filter?.toUpperCase() }}</span></b
                >
              </h2>
            </div>
            <div class="col-auto">
              <!-- @if ($profile != 'Agent Support') -->
              <div class="row align-items-center">
                <div class="col" v-if="form.ids.length">
                  <button
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#affectationModal"
                    id="affectationModalButton"
                    class="btn btn-white btn-sm w-100 d-flex align-items-center"
                  >
                    <i class="bi-arrow-up-right-square me-1"></i>
                    <span>Affectation</span>
                    <span
                      class="badge bg-soft-dark text-dark rounded-circle ms-1"
                      >{{ form.ids.length }}</span
                    >
                  </button>
                </div>
                <div class="col" v-if="form.ids.length">
                  <button
                    type="button"
                    class="btn btn-danger btn-sm w-100 d-flex align-items-center"
                    @click="
                      () => {
                        this.form.ids = [];
                      }
                    "
                  >
                    <i class="bi-x me-1"></i>
                    <span>Deselectionner</span>
                  </button>
                </div>
                <div class="col">
                  <div class="dropdown">
                    <button
                      type="button"
                      class="btn btn-white btn-sm w-100"
                      id="usersFilterDropdown"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded="false"
                    >
                      <i class="bi-filter me-1" ref="filter"></i> Filtrer
                      <!-- <span
                                                    class="badge bg-soft-dark text-dark rounded-circle ms-1">2</span> -->
                    </button>

                    <div
                      class="dropdown-menu dropdown-menu-sm-end dropdown-card card-dropdown-filter-centered"
                      aria-labelledby="usersFilterDropdown"
                      style="min-width: 42rem"
                    >
                      <div class="card">
                        <div class="card-header card-header-content-between">
                          <h5 class="card-header-title">Filtrer Dossier</h5>

                          <button
                            type="button"
                            @click="this.$refs.filter.click()"
                            class="btn btn-ghost-secondary btn-icon btn-sm ms-2"
                          >
                            <i class="bi-x-lg"></i>
                          </button>
                        </div>

                        <div class="card-body">
                          <form>
                            <div class="row mb-2">
                              <div class="col-sm mb-1">
                                <small class="mt-2 mb-1"
                                  ><b>Institution</b></small
                                >

                                <m-select
                                  :options="institutionItems"
                                  label="label"
                                  track-by="label"
                                  :multiple="false"
                                  :loading="institutionIsLoading"
                                  v-model="filterData.institution_id"
                                >
                                </m-select>
                              </div>
                            </div>
                            <div class="row mb-2">
                              <div class="col-sm mb-1">
                                <small class="mt-2 mb-1"><b>Canal</b></small>
                                <m-select
                                  :options="categoryItems"
                                  label="label"
                                  track-by="label"
                                  :multiple="false"
                                  :loading="categoryIsLoading"
                                  v-model="filterData.canal_id"
                                >
                                </m-select>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-12 mt-2 mb-1">
                                <small class=""><b>Date</b></small>
                              </div>

                              <div class="col-sm mb-4">
                                <i-range
                                  v-model="filterData.date"
                                  :max-date="new Date()"
                                  model-type="yyyy-MM-dd"
                                  multi-calendars
                                  range
                                  :enable-time-picker="false"
                                />
                              </div>
                            </div>

                            <div class="row mx-1">
                              <a
                                class="btn bg-soft-dark col-sm-4"
                                @click="resetFilterDataSubmit"
                                >Annuler</a
                              >
                              <a
                                class="btn btn-primary"
                                :class="'col-sm-7 ms-2 '"
                                @click="
                                  () => {
                                    getAll({
                                      ...this.filterResultData,
                                      filter: this.filter,
                                    });
                                  }
                                "
                                >Filtrer</a
                              >
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- @endif -->
            </div>
            <!-- End Col -->
          </div>
          <!-- End Row -->

          <!-- Tab Content -->
          <div class="tab-content" id="profileTeamsTabContent">
            <div
              class="tab-pane fade show active"
              id="grid"
              role="tabpanel"
              aria-labelledby="grid-tab"
            >
              <!-- Teams -->
              <div class="row" v-if="isLoading">
                <div class="col-lg-12 text-center">
                  <span class="spinner-grow" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </span>
                </div>
              </div>
              <div class="row" v-else-if="!items?.length">
                <div class="col-lg-12 text-center">
                  <h3>
                    <b
                      >Il n'y a pas de plainte disponible concernant cette
                      priorité.</b
                    >
                  </h3>
                </div>
              </div>
              <div class="row" v-else>
                <div
                  class="mb-3 mb-lg-5"
                  :class="[
                    expandList.includes(item.id)
                      ? 'col-lg-12'
                      : 'col-1 col-sm-2 col-lg-6 col-xl-6 col-xxl-4',
                  ]"
                  v-for="(item, i) in items"
                  @dblclick.stop="addToList(item.id)"
                  :key="i"
                >
                  <!-- Card -->
                  <div
                    :class="[
                      'card h-100',
                      form.ids.includes(item.id) ? 'selected' : '',
                    ]"
                  >
                    <!-- Body -->
                    <div class="card-body pb-0" style="max-height: 500px; overflow-y: auto;">
                      <div class="row">
                        <div class="col-lg-12">
                          <input
                            type="checkbox"
                            @click="addToList(item.id)"
                            :checked="form.ids.includes(item.id)"
                            name=""
                            id=""
                          />
                        </div>
                      </div>
                      <div class="row align-items-center mb-2">
                        <div
                          :class="
                            expandList.includes(item.id) ? 'col-10' : 'col-9'
                          "
                        >
                          <span
                            class="badge bg-soft-primary text-black"
                            style="font-size: 10px"
                          >
                            Référence : {{ item.reference }}
                          </span>
                          <div
                            class="d-flex align-items-center flex-wrap gap-2 my-1"
                            v-if="expandList.includes(item.id)"
                          >
                            <span
                              class="badge bg-soft-secondary text-black"
                              style="font-size: 10px"
                            >
                              Créé le : {{ item.created_at }}
                            </span>
                            <span
                              class="badge bg-soft-dark text-black"
                              style="font-size: 10px"
                            >
                              Canal :
                              {{
                                item.complaintsubcategory?.label ??
                                "Non spécifié"
                              }}
                            </span>
                            <span
                              class="badge"
                              :class="getStatusBadgeClass(item.complaint_status?.label)"
                              style="font-size: 10px"
                            >
                              <i class="bi bi-flag me-1"></i>
                              {{ item.complaint_status?.description ?? "Non spécifié" }}
                            </span>
                            <span
                              class="badge bg-soft-dark text-black"
                              style="font-size: 10px"
                            >
                              Division :
                              {{ item.division?.label ?? "Non spécifiée" }}
                            </span>
                            <span
                              class="badge bg-soft-primary text-primary"
                              style="font-size: 10px"
                              v-if="item.institution"
                            >
                              <i class="bi bi-building me-1"></i>
                              {{ item.institution.label }}
                            </span>
                          </div>

                          <h4 class="mb-1">
                            <a href="#">{{ item.subject }}</a>
                          </h4>
                        </div>
                        <!-- End Col -->

                        <div
                          class="text-end"
                          :class="
                            expandList.includes(item.id) ? 'col-2' : 'col-3'
                          "
                        >
                          <!-- Dropdown -->
                          <div class="">
                            <button
                              @click="expandCard(item.id)"
                              type="button"
                              class="btn btn-ghost-secondary btn-icon btn-sm rounded-circle"
                            >
                              <i
                                :class="
                                  expandList.includes(item.id)
                                    ? 'bi-arrows-angle-contract'
                                    : 'bi-arrows-angle-expand'
                                "
                              ></i>
                            </button>
                          </div>
                          <!-- End Dropdown -->
                        </div>
                        <!-- <div
                          :class="
                            expandList.includes(item.id)
                              ? 'col-1 text-end'
                              : 'col-2 text-end'
                          "
                        > -->
                        <!-- Dropdown -->
                        <!-- <div class="dropdowm">
                            <button
                              type="button"
                              class="btn btn-ghost-secondary btn-icon btn-sm rounded-circle"
                              id="teamsDropdown1"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="bi-three-dots-vertical"></i>
                            </button>

                            <div
                              class="dropdown-menu dropdown-menu-sm dropdown-menu-end"
                              aria-labelledby="teamsDropdown1"
                            >
                              <a class="dropdown-item" href="#"
                                >Traitement en interne à la CPD</a
                              >
                              <a class="dropdown-item" href="#"
                                >Envoi en traitement dans une Administration de
                                l'Etat
                              </a>
                              <a class="dropdown-item" href="#"
                                >Classement sans suite</a
                              >
                              <div class="dropdown-divider"></div>
                              <a class="dropdown-item text-danger" href="#"
                                >Supprimer</a
                              >
                            </div>
                          </div>
                          -->
                        <!-- End Dropdown -->
                        <!-- </div> -->
                        <!-- End Col -->
                      </div>
                      <!-- End Row -->
                      <b>Description:</b>
                      <p>
                        {{
                          item.description?.length < 1000 ||
                          showFullDescription.includes(item.id) ||
                          expandList.includes(item.id)
                            ? item.description
                            : truncate(item.description)
                        }}
                        
                        <a
                        href="#"
                          @click.prevent="toggleDescription(item.id)"
                          v-if="
                            item.description?.length > 1000 &&
                            !expandList.includes(item.id)
                          "
                        >
                          {{
                            showFullDescription.includes(item.id)
                              ? "Voir moins"
                              : "Voir plus"
                          }}
                        </a>
                      </p>
                      <div class="" v-if="item.ai_data">
                        <b>Resumer IA: <i class="bi bi-robot"></i></b>
                        <p>
                          {{
                            parsedSummary(item.ai_data?.summary)?.length < 1000 ||
                          showFullResume.includes(item.id) ||
                          expandList.includes(item.id) ?

                            parsedSummary(item.ai_data?.summary) :
                            truncate(parsedSummary(item.ai_data?.summary))
                          }}
                          <a
                        href="#"
                          @click.prevent="toggleDescription(item.id,false)"
                          v-if="
                            parsedSummary(item.ai_data?.summary)?.length > 1000 &&
                            !expandList.includes(item.id)
                          "
                        >
                          {{
                            showFullResume.includes(item.id)
                              ? "Voir moins"
                              : "Voir plus"
                          }}
                        </a>
                        </p>
                      </div>
                      <div
                        class=""
                        v-if="item.ai_data && expandList.includes(item.id)"
                      >
                        <b>Transcription IA: <i class="bi bi-robot"></i></b>
                        <pre
                          style="font-family: 'Montserrat'; color: black"
                          v-if="
                            !item.ai_data?.transcription?.includes('summary')
                          "
                          class="mt-0 text-sm rounded"
                        >
                                {{ item.ai_data?.transcription }}
                            </pre
                        >
                        <p v-else>
                          {{
                            JSON.parse(item.ai_data?.transcription ?? "")
                              ?.summary
                          }}
                        </p>
                      </div>
                    </div>
                    <!-- End Body -->

                    <!-- Footer -->
                    <div class="card-footer border-0 pt-0">
                      <div
                        class="list-group list-group-flush list-group-no-gutters"
                      >
                        <!-- List Item -->

                        <div class="list-group-item" v-if="item.institution">
                          <div class="row align-items-center " style="max-width: 100%;overflow-x: auto;">
                            <div class="col">
                              <span class="card-subtitle">Institution:</span>
                            </div>
                            <!-- End Col -->

                            <div class="col-auto">
                              <p
                                class="badge bg-soft-primary text-primary p-2"
                                style="word-break: break-word;overflow-wrap: break-word;    display: inline-block;
"
                                href="#"
                                >{{ item.institution?.label }}
                              </p>
                            </div>
                            <!-- End Col -->
                          </div>
                        </div>
                        <!-- End List Item -->
                        <div
                          class="list-group-item"
                          v-if="
                            item.ai_data?.insights &&
                            expandList.includes(item.id)
                          "
                        >
                          <div class="row align-items-center">
                            <div class="col">
                              <span class="card-subtitle"></span>
                            </div>
                            <!-- End Col -->

                            <div class="col-auto">
                              <a
                                v-for="(ins, key) in parsedInsight(
                                  item.ai_data?.insights
                                )"
                                :key="key"
                                class="badge bg-soft-info text-info p-2 me-1 mb-1"
                                href="#"
                                >{{ key }} : {{ ins }}
                              </a>
                            </div>
                            <!-- End Col -->
                          </div>
                        </div>
                        <div
                          class="list-group-item"
                          v-if="
                            item.ai_data?.keywords &&
                            expandList.includes(item.id)
                          "
                        >
                          <div class="row align-items-center">
                            <div class="col">
                              <span class="card-subtitle">Mots clés:</span>
                            </div>
                            <!-- End Col -->
                            <!-- {{ item.ai_data.keywords }} -->
                            <div class="col-auto">
                              <a
                                v-for="(key, i) in parsedKeywords(
                                  item.ai_data?.keywords
                                )"
                                :key="i"
                                class="badge bg-soft-warning text-warning p-2 me-1 mb-1"
                                href="#"
                                >{{ key }}
                              </a>
                            </div>
                            <!-- End Col -->
                          </div>
                        </div>

                        <!-- List Item -->
                        <div
                          class="list-group-item"
                          v-if="item.tracknumber != 0"
                        >
                          <div class="row align-items-center">
                            <div class="col">
                              <span class="card-subtitle">Audio:</span>
                            </div>
                            <!-- End Col -->

                            <div class="col-auto d-flex align-items-center gap-2">
                              <!-- Stars -->
                              <audio controls class="" style="max-width: 400px;">
                                <source
                                  :src="getAudioUrl(item.tracknumber)"
                                  type="audio/mp3"
                                />
                                Votre navigateur ne supporte pas la lecture
                                audio.
                              </audio>

                              <button
                                @click="downloadAudio(item.tracknumber, item.reference)"
                                class="btn btn-outline-success btn-sm"
                                title="Télécharger l'audio"
                              >
                                <i class="bi bi-download"></i>
                              </button>

                              <!-- End Stars -->
                            </div>
                            <!-- End Col -->
                          </div>
                        </div>
                        <!-- End List Item -->
                      </div>
                    </div>
                    <!-- End Footer -->
                  </div>
                  <!-- End Card -->
                </div>
              </div>

              <div class="row">
                <div class="col-12 text-end">
                  <b-pagination
                    :limit="10"
                    :keepLength="true"
                    :data="itemsMeta ?? {}"
                    :isApiResource="true"
                    @pagination-change-page="getResults"
                  />
                </div>
              </div>
              <!-- End Teams -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Button trigger modal -->
    <button
      type="button"
      class="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#affectationModal"
      id="affectationModalButtonClose"
      ref="affectationModalClose"
      style="display: none"
    ></button>
    <!-- End Button trigger modal -->

    <!-- Modal -->
    <div
      id="affectationModal"
      class="modal fade bd-example-modal-xl"
      tabindex="-1"
      role="dialog"
      aria-labelledby="affectationModalTitle"
      aria-hidden="true"
    >
      <form id="affectationModalForm" @submit.prevent="prepareBeforeAffecte">
        <div
          class="modal-dialog modal-dialog-centered modal-xl"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="affectationModalTitle">
                AFFECTATION
              </h5>
              <button
                type="button"
                class="btn-close"
                v-if="!affectationPlainteIsLoading"
                @click="s"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <div class="mb-3 tom-select-custom">
                <label class="form-label" for="affectation_mode"
                  >Type d'affectation</label
                >
                <select
                  placeholder="Type d'affectation"
                  v-model="affectationData.affectation_mode"
                  required
                  class="form-select form-control"
                  id=""
                >
                  <option
                    v-for="(affectation_mode, index) in affectationItems"
                    :key="index"
                    :value="affectation_mode.id"
                  >
                    {{ affectation_mode.label }}
                  </option>
                </select>
              </div>

              <div
                id="affectation_mode_1"
                v-if="affectationData.affectation_mode == 1"
              >
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label class="form-label" for="affectation_analystes"
                        >Analyste(s)</label
                      >
                      <m-select
                        :modelValue="affectation_analystes_select"
                        @update:modelValue="
                          (v, i) => {
                            this.affectationData.affectation_analystes_select_id =
                              v?.map(({ id }) => id);
                            this.affectation_analystes_select = v;
                          }
                        "
                        :loading="userIsLoading"
                        :required="true"
                        :options="userItems"
                        :multiple="true"
                        :allow-empty="false"
                        :searchable="true"
                        placeholder="Rechercher des analystes..."
                        track-by="id"
                        label="firstname"
                      >
                      </m-select>
                      <small class="text-muted" v-if="affectation_analystes_select?.length">
                        {{ affectation_analystes_select.length }} analyste(s) sélectionné(s)
                      </small>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label" for="affectation_division"
                        >Division</label
                      >
                      <m-select
                        v-model="affectationData.affectation_division_id"
                        :loading="divisionIsLoading"
                        :required="true"
                        :options="divisionItems"
                        :multiple="false"
                        :allow-empty="false"
                        :searchable="true"
                        placeholder="Rechercher une division..."
                        track-by="id"
                        label="label"
                      >
                      </m-select>
                      <div class="mt-2">
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-primary"
                          @click="toggleCreateDivision"
                        >
                          <i class="bi bi-plus-circle me-1"></i>
                          Créer une division
                        </button>
                      </div>
                      <div v-if="createNewDivision" class="mt-2 p-2 border rounded bg-light">
                        <div class="mb-2">
                          <label class="form-label text-sm">Nom de la division *</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            v-model="newDivisionData.label"
                            placeholder="Ex: Direction des études"
                          />
                        </div>
                        <div class="mb-2">
                          <label class="form-label text-sm">Code (optionnel)</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            v-model="newDivisionData.code"
                            placeholder="Ex: DIR-ETU"
                          />
                        </div>
                        <button
                          type="button"
                          class="btn btn-sm btn-success"
                          @click="createNewDivisionOnly"
                          :disabled="creatingDivision"
                        >
                          <i class="bi bi-check-circle me-1"></i>
                          {{ creatingDivision ? 'Création...' : 'Créer' }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-secondary ms-1"
                          @click="toggleCreateDivision"
                        >
                          Annuler
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="mb-3">
                      <label class="form-label" for="affectation_secteur"
                        >Secteur</label
                      >
                      <m-select
                        v-model="affectationData.affectation_secteur_id"
                        :loading="secteurIsLoading"
                        :required="true"
                        :options="secteurItems"
                        :multiple="false"
                        :allow-empty="false"
                        :searchable="true"
                        placeholder="Rechercher un secteur..."
                        track-by="id"
                        label="label"
                      >
                      </m-select>
                      <div class="mt-2">
                        <button
                          type="button"
                          class="btn btn-sm btn-outline-primary"
                          @click="toggleCreateSecteur"
                        >
                          <i class="bi bi-plus-circle me-1"></i>
                          Créer un secteur
                        </button>
                      </div>
                      <div v-if="createNewSecteur" class="mt-2 p-2 border rounded bg-light">
                        <div class="mb-2">
                          <label class="form-label text-sm">Nom du secteur *</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            v-model="newSecteurData.label"
                            placeholder="Ex: Secteur financier"
                          />
                        </div>
                        <div class="mb-2">
                          <label class="form-label text-sm">Division associée *</label>
                          <select
                            class="form-control form-control-sm"
                            v-model="newSecteurData.division_id"
                            required
                          >
                            <option :value="null">Sélectionner une division...</option>
                            <option
                              :value="division.id"
                              v-for="(division, index) in divisionItems"
                              :key="index"
                            >
                              {{ division.label }}
                            </option>
                          </select>
                        </div>
                        <div class="mb-2">
                          <label class="form-label text-sm">Code (optionnel)</label>
                          <input
                            type="text"
                            class="form-control form-control-sm"
                            v-model="newSecteurData.code"
                            placeholder="Ex: SEC-FIN"
                          />
                        </div>
                        <button
                          type="button"
                          class="btn btn-sm btn-success"
                          @click="createNewSecteurOnly"
                          :disabled="creatingSecteur"
                        >
                          <i class="bi bi-check-circle me-1"></i>
                          {{ creatingSecteur ? 'Création...' : 'Créer' }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-secondary ms-1"
                          @click="toggleCreateSecteur"
                        >
                          Annuler
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label class="form-label" for="affectation_observations"
                        >Dispositions particulières</label
                      >
                      <textarea
                        id="affectation_observations"
                        v-model="affectationData.affectation_observations1"
                        name="affectation_observations"
                        class="form-control"
                        placeholder="Dispositions particulières à observer lors du traitement du dossier. Appel à recourir à une documentation particulière"
                        rows="4"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="affectation_mode_2"
                v-if="affectationData.affectation_mode == 2"
              >
                <div class="mb-3 tom-select-custom">
                  <label class="form-label" for="affectation_institution"
                    >Administration</label
                  >
                  <m-select
                    v-model="affectationData.affectation_institution_id"
                    :loading="institutionIsLoading"
                    :required="true"
                    :options="institutionItems"
                    :multiple="false"
                    :allow-empty="false"
                    :searchable="true"
                    placeholder="Rechercher une administration..."
                    track-by="id"
                    label="label"
                  >
                  </m-select>
                  <div class="mt-2">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary"
                      @click="toggleCreateInstitution"
                    >
                      <i class="bi bi-plus-circle me-1"></i>
                      Créer une administration
                    </button>
                  </div>
                  <div v-if="createNewInstitution" class="mt-2 p-2 border rounded bg-light">
                    <div class="mb-2">
                      <label class="form-label text-sm">Nom de l'administration *</label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="newInstitutionData.label"
                        placeholder="Ex: Ministère de la Santé"
                      />
                    </div>
                    <div class="mb-2">
                      <label class="form-label text-sm">Type d'institution</label>
                      <select
                        class="form-control form-control-sm"
                        v-model="newInstitutionData.type"
                      >
                        <option :value="null">Sélectionner un type...</option>
                        <option
                          :value="type.id"
                          v-for="(type, index) in institutionTypeItems"
                          :key="index"
                        >
                          {{ type.label }}
                        </option>
                      </select>
                    </div>
                    <div class="mb-2">
                      <label class="form-label text-sm">Email (optionnel)</label>
                      <input
                        type="email"
                        class="form-control form-control-sm"
                        v-model="newInstitutionData.email"
                        placeholder="contact@institution.bj"
                      />
                    </div>
                    <div class="mb-2">
                      <label class="form-label text-sm">Téléphone (optionnel)</label>
                      <input
                        type="text"
                        class="form-control form-control-sm"
                        v-model="newInstitutionData.phone"
                        placeholder="+229 XX XX XX XX"
                      />
                    </div>
                    <button
                      type="button"
                      class="btn btn-sm btn-success"
                      @click="createNewInstitutionOnly"
                      :disabled="creatingInstitution"
                    >
                      <i class="bi bi-check-circle me-1"></i>
                      {{ creatingInstitution ? 'Création...' : 'Créer' }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-secondary ms-1"
                      @click="toggleCreateInstitution"
                    >
                      Annuler
                    </button>
                  </div>
                </div>
              </div>
              <div
                id="affectation_mode_3"
                v-if="affectationData.affectation_mode == 3"
              >
                <div class="mb-3 tom-select-custom">
                  <label class="form-label" for="affectation_motif"
                    >Motif</label
                  >
                  <select
                    class="form-control form-select"
                    v-model="affectationData.affectation_motif_id"
                    required
                    placeholder="Choisissez une division"
                  >
                    <option
                      :value="motif.id"
                      v-for="(motif, index) in motifItems"
                      :key="index"
                    >
                      {{ motif.label }}
                    </option>
                  </select>
                </div>
                <div class="mb-3">
                  <label class="form-label" for="affectation_observations1"
                    >Autres details</label
                  >
                  <textarea
                    id="affectation_observations1"
                    name="affectation_observations1"
                    class="form-control"
                    placeholder=""
                    v-model="affectationData.affectation_observations1"
                    rows="4"
                  ></textarea>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-white"
                v-if="!affectationPlainteIsLoading"
                data-bs-dismiss="modal"
              >
                Fermer
              </button>
              <button
                type="submit"
                class="btn btn-primary"
                v-if="!affectationPlainteIsLoading"
                id="affectation_submit_button"
              >
                Enregistrer
              </button>
              <button
                type="button"
                class="btn btn-primary"
                disabled
                v-else
                id="affectation_submit_button"
              >
                En cours de chargement
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
    <!-- End Modal -->
  </div>
</template>

<script>
import SubHeader from "@/layouts/admin/SubHeader.vue";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import { truncate } from "@/utils";
import backend from "@/utils/backend";
import notify from "@/utils/notify.js";

export default {
  name: "IAClassification",
  components: {
    SubHeader,
  },
  data() {
    return {
      form: {
        ids: [],
        institution_id: null,
        canal_id: null,
        start_date: null,
        end_date: null,
      },
      affectation_analystes_select: null,
      affectationData: {},
      expandList: [],
      filterData: {
        institution_id: null,
        canal_id: null,
        date: [],
      },
      filterResultData: {
        institution_id: null,
        canal_id: null,
        start_date: null,
        end_date: null,
      },
      showFullDescription: [],
      showFullResume: [],
      createNewDivision: false,
      newDivisionData: { label: '', code: '' },
      creatingDivision: false,
      createNewSecteur: false,
      newSecteurData: { label: '', code: '', division_id: null },
      creatingSecteur: false,
      createNewInstitution: false,
      newInstitutionData: { label: '', email: '', phone: '', type: null },
      creatingInstitution: false,
      institutionTypeItems: [],
      institutionTypeIsLoading: false,
    };
  },

  computed: {
    ...mapFields("ia/classification", {
      isLoading: "isLoading",
      isSuccess: "isSuccess",
      showMessage: "showMessage",
      message: "message",
      itemsMeta: "pagination",
      items: "items",
    }),
    filter() {
      return this.$route.params.filter;
    },
    ...mapFields("category/list", {
      categoryIsLoading: "isLoading",
      categoryIsSuccess: "isSuccess",
      categoryShowMessage: "showMessage",
      categoryMessage: "message",
      categorySubCategory: "subcategory",
      categoryItems: "items",
    }),
    ...mapFields("dossier/affectation", {
      affectationPlainteIsLoading: "isLoading",
      affectationPlainteIsSuccess: "isSuccess",
      affectationPlainteShowMessage: "showMessage",
      affectationPlainteMessage: "message",
      affectationPlainteIsCreated: "isUpdated",
      affectationPlainteItems: "updated",
    }),
    ...mapFields("affectation/list", {
      affectationIsLoading: "isLoading",
      affectationIsSuccess: "isSuccess",
      affectationShowMessage: "showMessage",
      affectationMessage: "message",
      affectationItems: "items",
    }),
    ...mapFields("user/list", {
      userIsLoading: "isLoading",
      userIsSuccess: "isSuccess",
      userShowMessage: "showMessage",
      userMessage: "message",
      userItems: "items",
    }),
    ...mapFields("institution/list", {
      institutionIsLoading: "isLoading",
      institutionIsSuccess: "isSuccess",
      institutionShowMessage: "showMessage",
      institutionMessage: "message",
      institutionItems: "items",
    }),

    ...mapFields("division/list", {
      divisionIsLoading: "isLoading",
      divisionIsSuccess: "isSuccess",
      divisionShowMessage: "showMessage",
      divisionMessage: "message",
      divisionItems: "items",
    }),
    ...mapFields("secteur/list", {
      secteurIsLoading: "isLoading",
      secteurIsSuccess: "isSuccess",
      secteurShowMessage: "showMessage",
      secteurMessage: "message",
      secteurItems: "items",
    }),
    ...mapFields("motif/list", {
      motifIsLoading: "isLoading",
      motifIsSuccess: "isSuccess",
      motifShowMessage: "showMessage",
      motifMessage: "message",
      motifItems: "items",
    }),

    subHeaderTitle() {
      const title = {
        base: "Dossiers Base",
        haut: "Dossiers Tres Important",
        medium: "Dossiers Moyen",
      };

      return title[this.$route.params.filter] ?? "Dossier";
    },
  },

  methods: {
    truncate,
    downloadAudio(tracknumber, reference) {
      if (tracknumber) {
        const audioUrl = this.getAudioUrl(tracknumber);
        const link = document.createElement('a');
        link.href = audioUrl;
        link.download = `audio_${reference}.mp3`;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        notify('Téléchargement de l\'audio démarré', 'success');
      }
    },
    getPriorityClass(filter) {
      const priorityClasses = {
        'haut': 'badge bg-danger text-white',
        'medium': 'badge bg-warning text-dark',
        'base': 'badge bg-info text-white'
      };
      return priorityClasses[filter] || 'badge bg-secondary text-white';
    },
    getStatusBadgeClass(statusLabel) {
      if (!statusLabel) return 'bg-secondary text-white';

      const status = statusLabel.toLowerCase();
      if (status.includes('nouveau') || status.includes('new')) {
        return 'bg-primary text-white';
      } else if (status.includes('encours') || status.includes('en cours') || status.includes('progress')) {
        return 'bg-info text-white';
      } else if (status.includes('affect') || status.includes('trait')) {
        return 'bg-warning text-dark';
      } else if (status.includes('clos') || status.includes('termin') || status.includes('resolu')) {
        return 'bg-success text-white';
      }
      return 'bg-secondary text-white';
    },
    prepareBeforeAffecte() {
      if (this.createNewDivision || this.createNewSecteur || this.createNewInstitution) {
        notify('Veuillez terminer la création en cours ou annuler avant d\'affecter.', 'warning')
        return
      }

      // Préparer les données selon le mode
      let dataToSend = {
        ids: this.form.ids,
        affectation_mode: this.affectationData.affectation_mode
      }

      if (this.affectationData.affectation_mode == 1) {
        // Mode interne
        dataToSend.affectation_analystes = this.affectationData.affectation_analystes_select_id || []
        dataToSend.affectation_division = this.affectationData.affectation_division || this.affectationData.affectation_division_id
        dataToSend.affectation_secteur = this.affectationData.affectation_secteur || this.affectationData.affectation_secteur_id
        dataToSend.affectation_observations = this.affectationData.affectation_observations1
      } else if (this.affectationData.affectation_mode == 2) {
        // Mode administration
        dataToSend.affectation_institution = this.affectationData.affectation_institution || this.affectationData.affectation_institution_id
      } else if (this.affectationData.affectation_mode == 3) {
        // Mode classement
        dataToSend.affectation_motif = this.affectationData.affectation_motif_id
        dataToSend.affectation_observations = this.affectationData.affectation_observations1
      }

      this.affectationHandleSubmit(dataToSend);
    },
    getAudioUrl(audioFile) {
      if (audioFile) {
        return `${process.env.VUE_APP_AUDIO_AND_IA_URL}/audio/${audioFile}`;
      }
    },
    toggleDescription(id,description= true) {
      const index = description ?this.showFullDescription.indexOf(id):this.showFullResume.indexOf(id);
      if (index != -1) {
        if(description){
          this.showFullDescription.splice(index, 1);
        }else{
          this.showFullResume.splice(index, 1);
        }
      } else {
        if(description){
          this.showFullDescription.push(id);
        }else{
          this.showFullResume.push(id);
        }
      }
    },
    getResults(page) {
      this.getAll({ ...this.filterResultData, filter: this.filter, page });
    },
    resetFilterDataSubmit() {
      this.filterData = {
        institution_id: null,
        canal_id: null,
        date: [],
      };
      this.form = {
        ids: this.form.ids,
        institution_id: null,
        canal_id: null,
        start_date: null,
        end_date: null,
      };
    },
     parsedInsight(insights) {
      try {
        if (insights == undefined) {
          return;
        }
        const parsed = JSON.parse(insights);
        if (parsed.Additionnel) {
          const additionnel = parsed.Additionnel;
          delete parsed.Additionnel;
          for (const [key, value] of Object.entries(additionnel)) {
            const formattedKey = key.replace(/_/g, " ");
            parsed[formattedKey] = value;
          }
        }
        return parsed;
      } catch (error) {
        console.error("Invalid JSON format:", error);
        return [];
      }
    },
      parsedSummary(summary) {
      try {
        if (summary == undefined) {
          return;
        }
        if(!summary.includes('"summary":')){
          return summary
        }
       
        return JSON.parse(summary).summary;
      } catch (error) {
        console.error("Invalid JSON format:", error);
        return summary;
      }
    },
    expandCard(id) {
      const index = this.expandList.indexOf(id);
      console.log(
        "this.items.filter((item)=>id == item.id)",
        this.items.filter((item) => id == item.id)
      );
      if (index != -1) {
        this.expandList.splice(index, 1);
      } else {
        this.expandList.push(id);
      }
    },
    parsedKeywords(keywords) {
      try {
        if (keywords == undefined) {
          return;
        }
        return JSON.parse(keywords).keywords;
      } catch (error) {
        console.error("Invalid JSON format:", error);
        return [];
      }
    },
    addToList(id) {
      const index = this.form.ids.indexOf(id);
      if (index != -1) {
        this.form.ids.splice(index, 1);
      } else {
        this.form.ids.push(id);
      }
    },

    toggleCreateDivision() {
      this.createNewDivision = !this.createNewDivision
      this.newDivisionData = { label: '', code: '' }
    },

    async createNewDivisionOnly() {
      if (!this.newDivisionData.label) {
        notify('Le nom de la division est obligatoire', 'error')
        return
      }
      this.creatingDivision = true
      try {
        const data = {
          label: this.newDivisionData.label,
          code: this.newDivisionData.code || null,
        }
        await backend({
          method: 'POST',
          url: '/divisions',
          data
        })
        notify(`Division "${this.newDivisionData.label}" créée avec succès !`, 'success')
        this.newDivisionData = { label: '', code: '' }
        this.createNewDivision = false
        await this.getDivisions()
        setTimeout(() => {
          notify('✅ Division ajoutée ! Sélectionnez-la maintenant.', 'info')
        }, 500)
      } catch (error) {
        console.error('Erreur lors de la création de la division:', error)
        const errorMsg = error.response?.data?.message || 'Impossible de créer cette division'
        notify(errorMsg, 'error')
      } finally {
        this.creatingDivision = false
      }
    },

    toggleCreateSecteur() {
      this.createNewSecteur = !this.createNewSecteur
      this.newSecteurData = { label: '', code: '', division_id: null }
    },

    async createNewSecteurOnly() {
      if (!this.newSecteurData.label) {
        notify('Le nom du secteur est obligatoire', 'error')
        return
      }
      if (!this.newSecteurData.division_id) {
        notify('Veuillez sélectionner une division', 'error')
        return
      }
      this.creatingSecteur = true
      try {
        const data = {
          label: this.newSecteurData.label,
          code: this.newSecteurData.code || null,
          division_id: this.newSecteurData.division_id,
        }
        await backend({
          method: 'POST',
          url: '/secteurs',
          data
        })
        notify(`Secteur "${this.newSecteurData.label}" créé avec succès !`, 'success')
        this.newSecteurData = { label: '', code: '', division_id: null }
        this.createNewSecteur = false
        await this.getSecteurs()
        setTimeout(() => {
          notify('✅ Secteur ajouté ! Sélectionnez-le maintenant.', 'info')
        }, 500)
      } catch (error) {
        console.error('Erreur lors de la création du secteur:', error)
        const errorMsg = error.response?.data?.message || 'Impossible de créer ce secteur'
        notify(errorMsg, 'error')
      } finally {
        this.creatingSecteur = false
      }
    },

    toggleCreateInstitution() {
      this.createNewInstitution = !this.createNewInstitution
      this.newInstitutionData = { label: '', email: '', phone: '', type: null }
    },

    async createNewInstitutionOnly() {
      if (!this.newInstitutionData.label) {
        notify('Le nom de l\'administration est obligatoire', 'error')
        return
      }
      this.creatingInstitution = true
      try {
        const data = {
          label: this.newInstitutionData.label,
          institutiontype_id: this.newInstitutionData.type || null,
          email: this.newInstitutionData.email || null,
          phone: this.newInstitutionData.phone || null,
        }
        await backend({
          method: 'POST',
          url: '/institutions',
          data
        })
        notify(`Administration "${this.newInstitutionData.label}" créée avec succès !`, 'success')
        this.newInstitutionData = { label: '', email: '', phone: '', type: null }
        this.createNewInstitution = false
        await this.getInstitutions()
        setTimeout(() => {
          notify('✅ Administration ajoutée ! Sélectionnez-la maintenant.', 'info')
        }, 500)
      } catch (error) {
        console.error('Erreur lors de la création de l\'administration:', error)
        const errorMsg = error.response?.data?.message || 'Impossible de créer cette administration'
        notify(errorMsg, 'error')
      } finally {
        this.creatingInstitution = false
      }
    },

    async getInstitutionTypes() {
      this.institutionTypeIsLoading = true
      try {
        const response = await backend({
          method: 'GET',
          url: '/institution-type'
        })
        this.institutionTypeItems = response.data.data || []
      } catch (error) {
        console.error('Erreur lors du chargement des types d\'institutions:', error)
        this.institutionTypeItems = []
      } finally {
        this.institutionTypeIsLoading = false
      }
    },

    

    ...mapActions({
      getAll: "ia/classification/getAll",
      reset: "ia/classification/resetData",
      affectationHandleSubmit: "dossier/affectation/updateMany",
      resetAffectationCreate: "dossier/affectation/resetData",
      getAffectations: "affectation/list/getAll",
      resetAffectations: "affectation/list/resetData",
      getSecteurs: "secteur/list/getAll",
      resetSecteurs: "secteur/list/resetData",
      getDivisions: "division/list/getAll",
      resetDivisions: "division/list/resetData",
      getMotifs: "motif/list/getAll",
      resetMotifs: "motif/list/resetData",
      getInstitutions: "institution/list/getAll",
      resetInstitutions: "institution/list/resetData",
      getUsers: "user/list/getAll",
      resetUsers: "user/list/resetData",
      getCategorys: "category/list/getAll",
      resetCategorys: "category/list/resetData",
    }),
  },

  watch: {
    filter() {
      this.reset();
      this.resetFilterDataSubmit();
      this.form.ids = [];

      this.getAll({ ...this.filterResultData, filter: this.filter });
    },
    "filterData.institution_id"() {
      this.filterResultData.institution_id =
        this.filterData.institution_id?.id ?? null;
    },
    "filterData.canal_id"() {
      this.filterResultData.canal_id = this.filterData.canal_id?.id ?? null;
    },
    "filterData.date"(val) {
      if (val?.length) {
        this.filterResultData.start_date = val[0];
        this.filterResultData.end_date = val?.length == 2 ? val[1] : null;
      } else {
        this.filterResultData.start_date = null;
        this.filterResultData.end_date = null;
      }
    },
    "affectationData.affectation_institution_id"(val) {
      if (val && typeof val === 'object' && val.id) {
        this.affectationData.affectation_institution = val.id
      } else if (val && typeof val === 'number') {
        this.affectationData.affectation_institution = val
      }
    },
    "affectationData.affectation_division_id"(val) {
      if (val && typeof val === 'object' && val.id) {
        this.affectationData.affectation_division = val.id
      } else if (val && typeof val === 'number') {
        this.affectationData.affectation_division = val
      }
    },
    "affectationData.affectation_secteur_id"(val) {
      if (val && typeof val === 'object' && val.id) {
        this.affectationData.affectation_secteur = val.id
      } else if (val && typeof val === 'number') {
        this.affectationData.affectation_secteur = val
      }
    },
    affectationPlainteIsSuccess() {
      if (this.affectationPlainteIsSuccess) {
        this.$refs.affectationModalClose.click();
        this.reset();
        this.resetAffectationCreate();
        (this.affectation_analystes_select = null), (this.form.ids = []);
        this.resetFilterDataSubmit();

        (this.affectationData = {}),
          this.getAll({ ...this.filterResultData, filter: this.filter });
      }
    },
  },
  mounted() {
    this.getAll({ ...this.filterResultData, filter: this.filter });
    this.getAffectations();
    this.getInstitutions();
    this.getDivisions();
    this.getSecteurs();
    this.getMotifs();
    this.getUsers();
    this.getCategorys();
    this.getInstitutionTypes();
  },
  unmounted() {
    this.reset();
    this.resetAffectations();
    this.resetInstitutions();
    this.resetDivisions();
    this.resetSecteurs();
    this.resetMotifs();
    this.resetAffectationCreate();
    this.resetCategorys();
  },
};
</script>
<style scoped>
.card.selected {
  border: 2px solid #0a3764;
  box-shadow: 0 4px 15px rgba(10, 55, 100, 0.3);
  transition: all 0.3s ease;
  transform: translateY(-3px);
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
}

.card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.card.selected:hover {
  box-shadow: 0 6px 20px rgba(10, 55, 100, 0.4);
}

/* Amélioration de la lisibilité des badges */
.badge {
  font-weight: 500;
  padding: 0.35em 0.65em;
}

/* Scrollbar élégante */
.card-body {
  scrollbar-width: thin;
  scrollbar-color: #0a3764 #f1f1f1;
}

.card-body::-webkit-scrollbar {
  width: 8px;
}

.card-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.card-body::-webkit-scrollbar-thumb {
  background: #0a3764;
  border-radius: 4px;
}

.card-body::-webkit-scrollbar-thumb:hover {
  background: #082d52;
}

/* Amélioration responsive */
@media (max-width: 768px) {
  .card-body {
    padding: 1rem;
    max-height: 400px;
  }
}
</style>
